const community_business_type=1
const community_source_platform=1
export default{
    community_business_type,
    community_source_platform
}